/**
 * EMPENHO POR ITEM DA ASSINATURA (backend #271 e #272).
 *
 * O empenho do contrato inteiro não cabe na FUNDETEC: a locação tem o empenho
 * 328/2026, estável, e o serviço muda a cada competência (238, 232, 232, 308).
 * O item do contrato passa a ter `empenhoNumber` próprio, lido na construção
 * da linha da fatura. Vazio = herda o empenho do contrato.
 *
 * ⚠️ O empenho do SERVIÇO não vai aqui: ele muda todo mês e continua entrando
 * pelo "Nº do Empenho desta fatura" no modal da fatura. Aqui é só empenho
 * estável.
 *
 * Não existe mais trava para dois itens do MESMO produto com empenhos
 * diferentes. Enquanto o backend ligava item do contrato e item da fatura pelo
 * `productId`, a tela recusava salvar esse caso; desde o #272 o empenho é
 * resolvido na construção de cada linha, e cada item sai com o seu (inclusive
 * na fatia de pró-rata). É o caso da SORRISO (contrato 114): o principal num
 * empenho e o aditivo do 192 noutro.
 *
 * O que continua valendo é a CONTAGEM: a locação da FUNDETEC são dois itens
 * (GRP2601 e DP722), e preencher só um faz metade da locação sair sem número.
 */

export const empenhoDoItem = (item: any): string => String(item?.empenhoNumber ?? '').trim();

/** Quantos itens têm empenho próprio, para a tela dizer o que foi preenchido. */
export const itensComEmpenhoProprio = (itens: any[]): number =>
  (Array.isArray(itens) ? itens : []).filter((it) => Number(it?.productId) > 0 && empenhoDoItem(it)).length;
